import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'combo-sexo',
  templateUrl: './combo-sexo.component.html',
  styleUrls: ['./combo-sexo.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboSexoComponent implements OnInit {

  @ViewChild('comboSexo', {static: false}) comboSexo;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Dados estáticos do sexo
    this.dados = [
      { id: 1, sigla: 'M', descricao: 'Masculino' },
      { id: 2, sigla: 'F', descricao: 'Feminino' }
    ];

    this.preencherCombo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { sigla: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
